import type { FC } from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";

import {
  TOOLTIP_DELAY_DURATION,
  type TTooltipProps,
} from "@/ui/components/overlay/Tooltip/Tooltip.config";

export const Tooltip: FC<TTooltipProps> = (
  {
    children,
    delayDuration = TOOLTIP_DELAY_DURATION,
    ...props
  },
) => (
  <TooltipPrimitive.Provider delayDuration={delayDuration}>
    <TooltipPrimitive.Root {...props}>
      { children }
    </TooltipPrimitive.Root>
  </TooltipPrimitive.Provider>
);

Tooltip.displayName = "Tooltip";
